<template>
	<div class="solution-summary pb-2">
		<b-card no-body v-if="mhlv_draft_products.length > 0">
			<b-card-header header-bg-variant="primary" header-class="p-2 text-white">
				MHLV Cases
			</b-card-header>
			<b-card-body class="px-4 py-2">
				<b-row class="mb-3 pt-2" v-for="(product, index) in mhlv_draft_products" :key="index">

					<b-col cols="12" md="3">
						<b-form-group label="Loan Type">
							<b-form-input v-model="product.product_detail.prod_mhlv_loan_type" type="text" required
								disabled></b-form-input>
						</b-form-group>
					</b-col>

					<b-col cols="12" md="3">
						<b-form-group label="Interest Rate (%)">
							<b-form-input v-model="product.product_detail.prod_mhlv_interest_rate" type="number" step="0.01"
								disabled></b-form-input>
						</b-form-group>
					</b-col>

					<b-col cols="12" md="3">
						<b-form-group label="Tenure (Year)">
							<b-form-input v-model="product.product_detail.prod_mhlv_tenure" type="number" step="1"
								disabled></b-form-input>
						</b-form-group>
					</b-col>

					<b-col cols="12" md="3">
						<b-form-group label="Installment">
							<b-form-input v-model="product.product_detail.prod_mhlv_installment" type="number" step="0.01"
								disabled></b-form-input>
						</b-form-group>
					</b-col>

					<b-col cols="12" md="3">
						<b-form-group label="Arrangement Fee Amount">
							<b-form-input v-model="product.product_detail.prod_mhlv_agreement_amt" type="number" step="0.01"
								disabled></b-form-input>
						</b-form-group>
					</b-col>

					<b-col cols="12" md="3">
						<b-form-group label="Arrangement Fee SST (%)">
							<b-form-input v-model="product.product_detail.prod_mhlv_agreement_rate_sst" type="number" step="0.01"
								disabled></b-form-input>
						</b-form-group>
					</b-col>

					<b-col ols="12" md="3">
						<b-form-group label="Total Arrangement Fee (RM)">
							<b-form-input v-model="product.product_detail.prod_mhlv_agreement_fees" type="text" required disabled
								placeholder="0.00"></b-form-input>
						</b-form-group>
					</b-col>

					<b-col cols="12" class="mx-auto mt-1 pb-1">
						<b-row>
							<b-col cols="12">
								<div class="d-flex justify-content-end align-items-center">
									<div>
										<el-button class="bg-success py-2 text-white" @click="convertProductToCaseHandler(product.prod_id)"
											:loading="is_loading.case && is_loading.value === product.prod_id"><small
												class="font-weight-bold text-white">CONVERT TO CASE</small>
										</el-button>
										<el-button class="bg-danger py-2 text-white" @click="removeProductHandler(product)"
											:loading="is_loading.case && is_loading.value === product.prod_id"><small
												class="font-weight-bold text-white">REMOVE</small>
										</el-button>
									</div>
								</div>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</b-card-body>
		</b-card>
		<div class="text-center mt-5" v-else>No draft found.</div>
	</div>
</template>
<script>
import { Image, Button, Select, Option } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { mapState, mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { useNotificationStore } from '@/stores/notificationStore'
import { useMessagingStore } from '@/stores/messagingStore'

export default {
	components: {
		CurrencyInput,
		[Image.name]: Image,
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	computed: {
		...mapState(useProductStore, ['mhlv_draft_products']),
	},
	data() {
		return {
			is_loading: {
				case: false,
				value: ''
			},
		}
	},
	methods: {
		...mapActions(useProductStore, ['removeProduct', 'convertProductToCase']),
		...mapActions(useNotificationStore, ['fetchEmailTemplate']),
		...mapActions(useMessagingStore, ['sendEmail']),
		resetIsLoading() {
			this.is_loading.case = false
			this.is_loading.value = null
		},
		async convertProductToCaseHandler(id) {
			this.is_loading.case = true
			this.is_loading.value = id
			try {
				await this.convertProductToCase(id, 'mhlv')
				await this.sendCaseApprovalEmail(id)
				this.resetIsLoading()
				_gNotif.notifySuccess('<b>Case Successfully Created </b> - Pending Approval.')
			} catch (e) {
				_gNotif.errorFunction(e)
				this.resetIsLoading()
				return
			}
		},
		async sendCaseApprovalEmail(id) {
			try {
				const emailTemplate = await this.fetchEmailTemplate('CREATE_CASE_APPROVAL');
				if (emailTemplate && emailTemplate.is_active == 1) {

					const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

					// Prepare the email data
					const emailData = {
						to: recipients,
						subject: emailTemplate.notif_temp_title,
						body: emailTemplate.notif_temp_message
							.replace('{case_id}', id) // Replace {case_id} with product ID
					};

					await this.sendEmail(emailData);
					_gNotif.notifySuccess('Email sent successfully.');
				}
			}
			catch (error) {
				console.error('Failed to send email:', error);
				_gNotif.errorFunction(error);
			}
		},
		async removeProductHandler(product) {
			this.is_loading.case = true
			this.is_loading.value = product.prod_id
			try {
				await this.removeProduct(product)
				_gNotif.notifySuccess('<b>Draft </b> - Successfully Removed.')
				this.resetIsLoading()
			} catch (e) {
				this.resetIsLoading()
				_gNotif.errorFunction(null, e)
			}
		}
	}
}
</script>